import { gql } from 'apollo-angular';

export const ADD_VEHICLE = gql`
  mutation AddVehicle($input: SavedVehicleInput!) {
    addVehicle(input: $input) {
      id
      vehicleType
      licensePlate
      vin
      vehicleId
      modificationId
      year
      selected
    }
  }
`;
